import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TieDetailsComponent } from './tie-details.component';

const routes: Routes = [
    {
        path: '',
        component: TieDetailsComponent,
        title: 'Team Match'
    },
    {
        path: 'match',
        loadChildren: () => import('../../matches/match-details/match-details.module').then(m => m.MatchDetailsPageModule)
    },
    {
        path: 'stream-view/:theme',
        component: TieDetailsComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TieDetailsPageRoutingModule { }
